import { getStatus } from './status.ts';

// Method to build initialState object with keys needed for SmartCardProvider from the SmartLinks endpoint response
export const getInitialState = (smartLinksResponse: any): Record<string, any> => {
	// If we didn't get a response from SmartLinks endpoint, exit
	if (!Array.isArray(smartLinksResponse) || smartLinksResponse?.length < 1) {
		return {};
	}

	return smartLinksResponse?.reduce((map, metadata) => {
		const status = metadata?.status;

		const body = metadata?.body;
		const url = metadata?.body?.data?.url;

		if (!url) {
			// failed to resolve url
			window['__SSR_SMARTLINKS_ERRORS__'] = window['__SSR_SMARTLINKS_ERRORS__'] || {};
			const smartLinksSSRErrorsByStatus = window['__SSR_SMARTLINKS_ERRORS__'];
			smartLinksSSRErrorsByStatus[status] = smartLinksSSRErrorsByStatus[status]
				? smartLinksSSRErrorsByStatus[status] + 1
				: 1;

			return map;
		}

		const cardState = {
			status: getStatus(status, metadata?.body?.meta?.access),
			details: body,
		};
		return {
			...map,
			[url]: cardState,
		};
	}, {});
};
